import React, { useState } from "react";
import { useParams } from "react-router-dom";
import { RiLink } from "react-icons/ri";
import Popup from "./Popup";
import Typography from "../../../Utility/Typography";
import Button from "../../../Utility/Button/Button";

/* ----------------- Sample Members ----------------- */
const members = [
  { name: "Meet" },
  { name: "Ashay Wanjarkar" },
  { name: "Daniel LeBoss" },
  { name: "David Adress" },
  { name: "Dov Pechman" },
  { name: "Elisheva Chait" },
  { name: "Farzana Rashid", role: "Project Manager" },
  { name: "Mukesh Bishnoi" },
  { name: "Nathan Akimov", location: "Israel" },
];

/* ------------- Helpers for Avatar ------------- */
const colors = ["bg-green-500", "bg-blue-500", "bg-purple-500", "bg-indigo-500", "bg-pink-500"];

const getInitials = (name) =>
  name
    .split(" ")
    .map((n) => n[0])
    .join("")
    .slice(0, 2)
    .toUpperCase();

const getColor = (i) => colors[i % colors.length];

/* ----------------- Component ----------------- */
const TeamProjects = () => {
  const { teamName } = useParams();
  const [showPopup, setShowPopup] = useState(false);
  const [projects, setProjects] = useState([]);

  const displayTeamName = teamName
    ? teamName
        .split("-")
        .map((w) => w.charAt(0).toUpperCase() + w.slice(1))
        .join("-")
    : "Team";

  const addProject = (project) => {
    if (!projects.find((p) => p.key === project.key)) {
      setProjects([...projects, project]);
    }
    setShowPopup(false);
  };

  return (
    <div className="p-6 bg-[#f7f8fa] min-h-screen">
      <div className="max-w-7xl mx-auto bg-white rounded-xl shadow-sm p-6">
        {/* Header */}
        <div className="flex justify-between items-center mb-4">
          <Typography variant="h2" className="text-2xl font-semibold">
            {displayTeamName}
          </Typography>
          <Button variant="primary" size="sm">
            Request to join team
          </Button>
        </div>

        {/* Tabs */}
        <div className="flex gap-6 border-b mb-6">
          {["About"].map((t) => (
            <Button
              variant="primary"
              key={t}
              className="pb-2 border-b-2 border-blue-500 text-blue-600 font-medium"
              size="sm"
            >
              {t}
            </Button>
          ))}
        </div>

        <div className="grid grid-cols-12 gap-6">
          {/* LEFT: Members */}
          <div className="col-span-8">
            <Typography variant="h3" className="font-semibold mb-3 flex items-center gap-2">
              Members
              <Typography variant="span1" className="text-xs bg-gray-200 rounded px-2">
                {members.length}
              </Typography>
            </Typography>

            <div className="grid grid-cols-2 gap-4">
              {members.map((m, i) => (
                <div
                  key={i}
                  className="border rounded-lg p-3 flex items-center gap-3 hover:shadow-sm"
                >
                  {m.img ? (
                    <img src={m.img} alt={m.name} className="w-12 h-12 rounded object-cover" />
                  ) : (
                    <div
                      className={getColor(i)}
                      style={{
                        width: 40,
                        height: 40,
                        borderRadius: "50%",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        color: "#fff",
                        fontWeight: 600,
                        fontSize: 18,
                        lineHeight: "40px",
                        flexShrink: 0,
                      }}
                    >
                      {getInitials(m.name)}
                    </div>
                  )}

                  <div>
                    <Typography variant="span2" className="font-medium" component="p">
                      {m.name}
                    </Typography>

                    {(m.role || m.location) && (
                      <Typography variant="span2" className="text-sm text-gray-500" component="p">
                        {[m.role, m.location].filter(Boolean).join(" · ")}
                      </Typography>
                    )}
                  </div>
                </div>
              ))}
            </div>
          </div>

          {/* RIGHT: Team Links */}
          <div className="col-span-4 space-y-4">
            <div className="border rounded-lg p-4">
              <div className="flex justify-between items-center mb-2">
                <Typography variant="span2" className="font-semibold" component="p">
                  Team links ({projects.length})
                </Typography>
                <Button variant="primary" size="sm" onClick={() => setShowPopup(true)}></Button>
              </div>

              {projects.map((p) => (
                <div key={p.key} className="flex items-center gap-2 text-sm mb-2">
                  <RiLink /> {p.name}
                </div>
              ))}
              <Button variant="primary" size="sm" onClick={() => setShowPopup(true)}>
                Add Project
              </Button>
            </div>
          </div>
        </div>
      </div>

      {showPopup && <Popup onSelect={addProject} onClose={() => setShowPopup(false)} />}
    </div>
  );
};

export default TeamProjects;
